module.exports = __webpack_public_path__ + "static/media/killarney.0b25b95a.png";